import { createFileRoute } from '@tanstack/react-router';
import { ActivityLogsRouteView } from '@/pages/workspaces/activity-logs/routing';

function ProfileActivityRoute() {
  const { workspaceId, tab } = Route.useParams();
  return <ActivityLogsRouteView segment="profile_activity" workspaceId={workspaceId} tab={tab} />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/profile_activity/$tab')({
  component: ProfileActivityRoute,
});
